// src/routes/adminRoutes.js
import React from 'react';
import { Route } from 'react-router-dom';
import { Outlet } from 'react-router-dom';

import ProtectedRoute from '../components/ProtectedRoute';
import AdminNavbar from '../views/Admin/AdminNavbar';
import AdminClients from '../views/Admin/AdminClients';
import AdminProposal from '../views/Admin/AdminProposal';
import LeadsList from '../views/Admin/LeadsList';
import AdminInvoices from '../views/Admin/AdminInvoices';
import ClientLayout from '../views/Admin/ClientLayout';
import ClientEmail from '../views/Admin/ClientEmail';
import ClientProfile from '../views/Shared/ClientProfile';
import LandingAdmin from '../views/Admin/LandingAdmin';
import BookMeLandingAdmin from '../views/Admin/BookMeLandingAdmin';
import EcommerceAdmin from '../views/Admin/EcommerceAdmin';
import AllInvoices from '../views/Admin/AllInvoices';
import AllProposals from '../views/Admin/AllProposals';
import AdminDashboard from '../views/Admin/AdminDashboard';
import ClientTracking from '../views/Admin/ClientTracking';
import AdminSales from '../views/Admin/AdminSales';
import ServiceDesk from '../views/Admin/ServiceDesk';
import AdminClientService from '../views/Admin/AdminClientService';
import OperationsBoard from '../views/Admin/OperationsBoard';


const AdminLayout = () => (
  <ProtectedRoute allowedRoles={['admin']}>
    <>
      <AdminNavbar />
      <Outlet />
    </>
  </ProtectedRoute>
);

const adminRoutes = (
  <Route path="/admin" element={<AdminLayout />}>
    {/* Home del panel */}
    <Route index element={<AdminDashboard />} />              {/* 👈 ahora /admin muestra el dashboard */}
    <Route path="dashboard" element={<AdminDashboard />} />   {/* 👈 acceso directo /admin/dashboard */}

    <Route path="clients" element={<AdminClients />} />
    <Route path="sales" element={<AdminSales />} />
    <Route path="services" element={<ServiceDesk />} />
    <Route path="clients/:clientId" element={<ClientLayout />}>
      <Route path="tracking" element={<ClientTracking />} />
      <Route path="proposal" element={<AdminProposal />} />
      <Route path="invoices" element={<AdminInvoices />} />
      <Route path="email" element={<ClientEmail />} />
      <Route path="profile" element={<ClientProfile />} />
      <Route path="service" element={<AdminClientService />} />
    </Route>

    <Route path="leads" element={<LeadsList />} />
    <Route path="landing-editor" element={<LandingAdmin />} />
    <Route path="bookme-landing" element={<BookMeLandingAdmin />} />
    <Route path="ecommerce" element={<EcommerceAdmin />} />
    <Route path="operations" element={<OperationsBoard />} />
    <Route path="invoices-global" element={<AllInvoices />} />
    <Route path="proposals-global" element={<AllProposals />} />
    <Route path="*" element={<h2>Ruta admin no encontrada</h2>} />
  </Route>
);

export default adminRoutes;
